export enum PlayerVerifyDocumentV2StatusEnum {
  NOTEXISTS = -1,
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
  RETURNED = 4,
}
